function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import shared from "./shared";
const unorderedStyles = {
  disc: "disc",
  circle: "circle",
  square: "square"
};
const Ul = styled.ul.withConfig({
  componentId: "sc-vp7s3q-0"
})(["", ";list-style-type:", ";"], shared, _ref => {
  let {
    listStyle
  } = _ref;
  return unorderedStyles[listStyle];
});

const Unordered = _ref2 => {
  let {
    children,
    listStyle = "disc",
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Ul, _extends({
    listStyle: listStyle
  }, props), children);
};

Unordered.propTypes = {
  /** List items */
  children: PropTypes.node.isRequired,

  /** What to display before each list item */
  listStyle: PropTypes.oneOf(Object.keys(unorderedStyles))
};
export default Unordered;